import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Algal biofuel has emerged as a viable, sustainable solution to
              meet the growing demand for energy while addressing the
              environmental issues associated with the GHG footprint. Integrated
              bioprocessing through biorefinery approach by utilizing spent
              biomass after oil extraction can be used as a raw material for
              various energy products like bioethanol, methane, and biocrude and
              biofertilizers. The techno- economic analysis of microalgal
              biorefinery has demonstrated positive aspects such as (i) using
              appropriate substrates for microalgal attachment that considerably
              reduces the costs involved in harvesting; (ii) use of wastewater
              for optimal biomass production with reduced biodiesel production
              costs and less payback period; (iii) use of biocatalyst, though it
              increases the capital investment, environmental impli- cations of
              mineral acids could be avoided which leads to significant
              environmental benefits. The utilization of microalgae grown using
              nutrient-rich wastewaters in an integrated biorefinery shows
              potential prospects in considerable energy and cost reduction.
              Establishing algal refineries at decentralized levels, especially
              along the Indian coasts, would empower local women of fisherfolk
              communities with secured livelihood opportunities with assured job
              opportunities.
            </p>
            <p>
              <strong>Acknowledgements </strong>Authors are grateful to (i) the
              NRDMS division, Ministry of Science and Technology, Government of
              India [CES/TVR/DST1045], and (ii) the Indian Institute of Science
              for the infrastructure support for ecological research. The
              authors thank Sreekanth Naik, Vishnu D Mukri, and Gayatri Naik for
              their assistance during the field data collection. The official
              languages section scrutinized this MS at IISc (language editing).
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
